import checkSvg from '$lib/assets/branding/icons/linear-gradient-check.svg'
import auditIcon from '$lib/assets/branding/Image-7.png'
import mainnetIcon from '$lib/assets/branding/Image-2.png'
import governanceIcon from '$lib/assets/branding/Image-1.png'
import openSourceIcon from '$lib/assets/branding/Image-8.png'

type Images = {
  checkSvg: string
  auditIcon: string
  mainnetIcon: string
  governanceIcon: string
  openSourceIcon: string
}

export const images: Images = {
  checkSvg,
  auditIcon,
  mainnetIcon,
  governanceIcon,
  openSourceIcon,
}
